import React from "react";
import { Stack, CloseButton, Box } from "@chakra-ui/react";

interface SpeakerContainerProps {
  onRemoveClick: () => void;
  showCloseButtons: boolean;
}

const SpeakerContainer: React.FC<SpeakerContainerProps> = (props) => {
  const { children, showCloseButtons, onRemoveClick } = props;
  return (
    <Stack
      position="relative"
      spacing={4}
      borderWidth={1}
      p={5}
      shadow="sm"
      borderRadius={5}
    >
      {showCloseButtons && (
        <Box position="absolute" right={0} mr={5} zIndex={1}>
          <CloseButton onClick={() => onRemoveClick()} />
        </Box>
      )}
      {children}
    </Stack>
  );
};

export default SpeakerContainer;
